<template>
    <el-dialog
        custom-class="full-dialog"
        :title="$l('streamPopover/Audio')+' - '+data.filename"
        :visible.sync="data.visible"
        size="auto"
        >
        
        <div class="container">
            <audio ref="audioController" @loadeddata="audioLoaded" class="audio-controller" v-if="data.filename" controls> 
                <source v-bind:src="fileSource">    
            </audio>
            <img class="img-popup" :src="imgSource" @click="setImgBig"></img>
            
        </div>
        <span slot="footer" class="dialog-footer"> 
            <img class="img-big" :src="imgSourceBig" @click="close"></img>
            <el-button @click="close">{{$l('archives/Close')}}</el-button>
        </span>
    </el-dialog>
</template>

<style>
    .container{
        text-align:center;
    }
    .img-popup {
        width: 200px;
        padding: 20px 10px 0 10px;
    }
    .img-big {
        width: 100%;
        float: left;
        padding-bottom: 20px;
    }


    /* Custom, iPhone Retina */ 
    @media only screen and (min-width : 320px) {
        .full-dialog{width: 90%;}
    }
    /* Extra Small Devices, Phones */ 
    @media only screen and (min-width : 480px) {
        .full-dialog{width: 90%;}
    }

    /* Small Devices, Tablets */
    @media only screen and (min-width : 768px) {
        .full-dialog{width: 60%;}
    }

    /* Medium Devices, Desktops */
    @media only screen and (min-width : 992px) {
        .full-dialog{width: 40%;}
    }

    /* Large Devices, Wide Screens */
    @media only screen and (min-width : 1200px) {
        .full-dialog{width: 30%;}
    }
</style>

<script>
export default {
    props:['data'],
    data:function() {
        return{
            imgSource: "",
            imgSourceBig: "",
        }
    },
    computed:{
        fileSource : function(){
            if(this.data.filename){
                
                var filename = this.data.filename;
                //2017-08-18-09-41-02.mp3
                var date = filename.split('.')[0].split('-').slice(0,3).join('-');
                //console.log('/audio/audio/'+date+'/'+this.data.filename)
                return '/audio/audio/'+date+'/'+this.data.filename;
            }
            return false;
        },
    },
    methods: {
        audioLoaded: function(){
            var audioController  = this.$refs.audioController;
            audioController.currentTime = 0;
            this.imgSourceBig = false;
            this.imgSource = this.imgLoad();
        },
        imgLoad: function() {
            if(this.data.filename){
                var filename = this.data.filename.substring(0,this.data.filename.length-4)+'.png';
                //2017-08-18-09-41-02.mp3
                var date = filename.split('.')[0].split('-').slice(0,3).join('-');
                this.imgSourceBig = "";
                return '/audio/audio/'+date+'/thumbnails/'+filename;
            }
            return false;
        },
        setImgBig: function() {
            if(this.data.filename){
                var filename = this.data.filename.substring(0,this.data.filename.length-4)+'.png';
                //2017-08-18-09-41-02.mp3
                var date = filename.split('.')[0].split('-').slice(0,3).join('-');
                this.imgSourceBig = '/audio/audio/'+date+'/'+filename;
                this.imgSource = "";
            }
            return false;
        },
        close: function(){
            this.data.visible = false
            this.data.filename = undefined
            this.imgSourceBig = ""
            this.imgSource = ""
            

        }
    },
    watch: {
        'data.visible': function(value){
            if (!value){
                this.data.visible = false
                this.data.filename = undefined
                this.imgSourceBig = ""
                this.imgSource = ""
                
            }
            //this.data = JSON.parse(JSON.stringify(this.data));
            //console.log(this.fileSource);
            
        }
    }
}
</script>



// WEBPACK FOOTER //
// PlayAudioFileDialog.vue?16dd3a97